var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      !_vm.showPhoneDialog
        ? _c("p", { staticClass: "login_title" }, [
            _vm._v(_vm._s(_vm.$t("m.scan_code")))
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.showPhoneDialog
        ? _c("scan", {
            ref: "qcode",
            attrs: { agreeXieyi: _vm.agreeXieyi, type: 1 },
            on: { showBindDialog: _vm.showBindDialog }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showPhoneDialog
        ? _c("bind-phone-pwd", {
            ref: "phonePwd",
            on: { cancelSet: _vm.cancelSet }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a1332e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a1332e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/scanLogin.vue
// module id = null
// module chunks = 